import React, { useState, useEffect } from "react"
import { Link, useLocation, useNavigate } from "react-router-dom"

const LOCALSTORAGE_KEY = "isAdmin"

export default function Navbar() {
  const location = useLocation()
  const navigate = useNavigate()

  const [menuOpen, setMenuOpen] = useState(false)
  const [isAdmin, setIsAdmin] = useState(
    typeof window !== "undefined" &&
      localStorage.getItem(LOCALSTORAGE_KEY) === "true"
  )

  useEffect(() => {
    const sync = () => {
      const v = localStorage.getItem(LOCALSTORAGE_KEY) === "true"
      setIsAdmin(v)
    }
    sync()
    window.addEventListener("storage", sync)
    return () => window.removeEventListener("storage", sync)
  }, [])

  const navItems = [
    { label: "Home", path: "/" },
    { label: "Web Design", path: "/web-design-adelaide" },
    { label: "Google Ads", path: "/google-ads-adelaide" }, // added
    { label: "Why Websites", path: "/whywebsites" },
    { label: "Portfolio", path: "/portfolio" },
    { label: "Health Check", path: "/website-health-check" },
    { label: "Contact", path: "/contact" },
    { label: "Blog", path: "/blog" },
  ]

  const privateNavItems = [
    { label: "Private Health Check", path: "/private-health-check" },
    { label: "Landing Index", path: "/lp-index-72a9" },
  ]

  const toggleMenu = () => setMenuOpen(!menuOpen)
  const closeMenu = () => setMenuOpen(false)

  const isActive = (path) =>
    location.pathname === path || location.pathname.startsWith(path + "/")

  const handleLogout = () => {
    localStorage.removeItem(LOCALSTORAGE_KEY)
    setIsAdmin(false)
    closeMenu()
    navigate("/")
  }

  const loginUrl = `/private/login?next=${encodeURIComponent(
    location.pathname + location.search
  )}`

  return (
    <header className="fixed top-0 left-0 right-0 bg-white z-[9999] shadow-sm">
      <nav className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
        <Link
          to="/"
          className="text-xl font-bold text-blue-700"
          onClick={closeMenu}
        >
          2merative
        </Link>

        <div className="hidden md:flex items-center space-x-6">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              onClick={closeMenu}
              className={`text-sm font-medium transition duration-300 ${
                isActive(item.path)
                  ? "text-blue-700 font-bold"
                  : "text-gray-700 hover:text-blue-600"
              }`}
            >
              {item.label}
            </Link>
          ))}

          {isAdmin ? (
            <>
              <span className="mx-2 text-gray-300">|</span>
              {privateNavItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={closeMenu}
                  className={`text-sm font-medium transition duration-300 ${
                    isActive(item.path)
                      ? "text-blue-700 font-bold"
                      : "text-gray-700 hover:text-blue-600"
                  }`}
                >
                  {item.label}
                </Link>
              ))}
              <button
                onClick={handleLogout}
                className="text-sm font-medium text-gray-700 hover:text-red-600 transition duration-300"
              >
                Logout
              </button>
            </>
          ) : (
            <Link
              to={loginUrl}
              onClick={closeMenu}
              className="text-sm font-medium text-gray-700 hover:text-blue-600 transition duration-300"
            >
              Admin Login
            </Link>
          )}
        </div>

        <button
          className="md:hidden text-gray-700 focus:outline-none"
          onClick={toggleMenu}
          aria-label="Toggle Menu"
          aria-expanded={menuOpen}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
          >
            {menuOpen ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4 6h16M4 12h16M4 18h16"
              />
            )}
          </svg>
        </button>
      </nav>

      {menuOpen && (
        <div className="md:hidden bg-white shadow-md px-4 py-3 space-y-2">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              onClick={closeMenu}
              className={`block text-sm font-medium ${
                isActive(item.path)
                  ? "text-blue-700 font-bold"
                  : "text-gray-700 hover:text-blue-600"
              }`}
            >
              {item.label}
            </Link>
          ))}

          {isAdmin ? (
            <>
              <div className="border-t my-2" />
              {privateNavItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={closeMenu}
                  className={`block text-sm font-medium ${
                    isActive(item.path)
                      ? "text-blue-700 font-bold"
                      : "text-gray-700 hover:text-blue-600"
                  }`}
                >
                  {item.label}
                </Link>
              ))}

              <button
                onClick={handleLogout}
                className="block w-full text-left text-sm font-medium text-gray-700 hover:text-red-600"
              >
                Logout
              </button>
            </>
          ) : (
            <Link
              to={loginUrl}
              onClick={closeMenu}
              className="block text-sm font-medium text-gray-700 hover:text-blue-600"
            >
              Admin Login
            </Link>
          )}
        </div>
      )}
    </header>
  )
}